export default "__VITE_ASSET__2f496d03__"